import { Navigate, useLocation } from 'react-router-dom'

import { unsetCurrentTenantConfig } from '..'
import { useTenantById } from '../../../data/tenants'

type TenantValidatorProps = {
  tenantId: string
  children?: React.ReactNode
}

export const TenantValidator: React.FC<TenantValidatorProps> = ({
  tenantId,
  children,
}) => {
  const { pathname } = useLocation()
  const { error } = useTenantById(tenantId)

  if (pathname && !pathname.toLowerCase().startsWith('/set-tenant') && error) {
    unsetCurrentTenantConfig()
    return <Navigate to="/set-tenant" />
  }

  return <>{children}</>
}
